import DateFnsUtils from "@date-io/date-fns";
import { ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { errorInterceptor } from "api/globalaxios";
import { IntlProviderWrapper } from "contexts/IntlContext";
import { SnackbarProvider } from "contexts/SnackbarContext";
import FullPageSpinner from "features/common/FullPageSpinner";
import NewTheme from "NewTheme";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import {
  isACCB,
  isArb,
  isDifc,
  isKilumaya,
  isMSME,
  isMuthoot,
  isNalsar,
  isOrix,
  isPaytm,
  isSebi,
  isStar,
  isTdsat,
  isTiac,
} from "Routes/Routes";
import theme from "theme";
import App from "./App";
import store from "./app/store";
import "./i18n.js";
import "./index.css";
import { ResumeFillingProvider } from "contexts/ResumeFilling";
import ACCBTheme from "Clients/ACCB/ACCBTheme";
import "./Clients/ACCB/accbScrollbars.css";

errorInterceptor(store);

const setDocumentBranding = () => {
  if (isArb) {
    document.title = "IIDRC";
    const metaDescription = document.querySelector(
      "meta[name='description']"
    );
    if (metaDescription) {
      metaDescription.setAttribute("content", "IIDRC");
    }
    return;
  }

  document.title = "Webnyay ODR platform";
};

if (isACCB) {
  document.documentElement.classList.add("accb-scrollbars");
}

// Set favicon based on platform
if (isArb) {
  const faviconLink = document.querySelector("link[rel='icon']");
  if (faviconLink) {
    faviconLink.href = "/favicon_iidrc.png";
  }
}

setDocumentBranding();

if (isSebi || isNalsar) {
  const script = document.createElement("script");
  script.src = "https://website-widgets.pages.dev/dist/sienna.min.js";
  script.defer = true;
  document.body.appendChild(script);
}

const Main = () => (
  <React.StrictMode>
    <Suspense fallback={<FullPageSpinner />}>
      <Provider store={store}>
        <IntlProviderWrapper>
          <ThemeProvider
            theme={
              isSebi ||
              isMSME ||
              isTiac ||
              isDifc ||
              isArb ||
              isKilumaya ||
              isPaytm ||
              isStar ||
              isMuthoot ||
              isTdsat ||
              isOrix ||
              isNalsar
                ? NewTheme
                : isACCB
                ? ACCBTheme
                : theme
            }
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <SnackbarProvider>
                <ResumeFillingProvider>
                  <App />
                </ResumeFillingProvider>
              </SnackbarProvider>
            </MuiPickersUtilsProvider>
          </ThemeProvider>
        </IntlProviderWrapper>
      </Provider>
    </Suspense>
  </React.StrictMode>
);

ReactDOM.render(<Main />, document.getElementById("root"));
